<script>
// Extensions
import View from "@/views/View";

// Mixins
import LoadSections from "@/mixins/load-sections";

export default {
  name: "SuretyShip",

  metaInfo: { title: "SuretyShip Dashboard" },

  extends: View,

  mixins: [LoadSections(["suretyship", "info"])],

  props: {
    id: {
      type: String,
      default: "SuretyShip"
    }
  }
};
</script>
